import { createApi } from "@reduxjs/toolkit/query/react";
import { arnoldBaseQuery } from "../baseQuery";
import { API_ROOT } from "../../utils/constants";

const RESOURCE = "authentication";
const ENDPOINT = `${API_ROOT}${RESOURCE}`;

export const AUTH_API_REDUCER_KEY = "authApi";

export const api = createApi({
    reducerPath: AUTH_API_REDUCER_KEY,
    baseQuery: arnoldBaseQuery,
    endpoints: (builder) => ({
        logout: builder.mutation<void, void>({
            query: () => ({
                url: ENDPOINT,
                method: "DELETE",
            }),
        }),
    }),
});

export const { useLogoutMutation } = api;
